import { Loading, Table } from "@nextui-org/react";
import { Fragment, useEffect, useState } from "react";
import { Text, Button } from "@nextui-org/react";
import { motion } from "framer-motion";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  TbArrowBackUp,
  TbFileExport,
  TbTag,
  TbUserCircle,
} from "react-icons/tb";
import ReportTable from "../components/CityTable";
import * as Xlsx from "xlsx";
import { useSelector } from "react-redux";

let sortFields = [
  "card",
  "cash",
  "cashfree",
  "ma",
  "online",
  "other",
  "otherBank",
  "otherCard",
  "otherCash",
  "otherMa",
  "products",
  "total",
];

const CityReport = () => {
  const token = useSelector((state) => state.invtry.token);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [voucherLoading, setVoucherLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState(false);
  const dateGte = searchParams.get("gte");
  const dateLte = searchParams.get("lte");

  const [currentList, setCurrentList] = useState([]);
  const [currentListAdj, setCurrentListAdj] = useState([]);
  const [currentSearch, setCurrentSearch] = useState("");
  const [currentSort, setCurrentSort] = useState({
    field: "_id",
    asc: true,
  });
  const changeCurrentSort = (field, asc) => {
    setCurrentSort({ field: field, asc: asc });
  };

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    fetch(`/group-city-orders?gte=${dateGte}&lte=${dateLte}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        if (!res.ok) {
          setError(true);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setCurrentList(data);
        setCurrentListAdj(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  //Sorting Logic
  useEffect(() => {
    if (currentList.length > 0) {
      let listCopy = [...currentList];
      let sortCurrent;

      if (currentSearch !== "") {
        const regexp = new RegExp(currentSearch, "i");
        listCopy = listCopy.filter((doc) => regexp.test(doc._id));
      }

      sortCurrent = listCopy.sort((a, b) => {
        const field = currentSort.field;

        const getValue = (doc) => {
          switch (field) {
            case "_id":
              return doc._id?.toLowerCase() ?? "";
            case "orders":
              return doc.orders?.length ?? 0;
            case "products":
              return doc.products ?? 0;
            case "card":
              return (doc.card ?? 0) + (doc.otherCard ?? 0);
            case "cash":
              return (doc.cash ?? 0) + (doc.otherCash ?? 0);
            case "cashfree":
              return (doc.cashfree ?? 0) + (doc.otherCash ?? 0);
            case "ma":
              return (doc.ma ?? 0) + (doc.otherMa ?? 0);
            case "online":
              return doc.online ?? 0;
            case "udhar":
              return doc.udhar ?? 0;
            case "otherReplace":
              return doc.otherReplace ?? 0;
            case "total":
              return doc.total ?? 0;
            default:
              return 0;
          }
        };

        const valA = getValue(a);
        const valB = getValue(b);

        if (typeof valA === "string" && typeof valB === "string") {
          return valA.localeCompare(valB);
        } else {
          return valA - valB;
        }
      });

      setCurrentListAdj(currentSort.asc ? sortCurrent : sortCurrent.reverse());
    }
  }, [currentSort, currentSearch, currentList]);

  const downloadExcel = () => {
    setExportLoading(true);

    const data = currentList.map((doc) => ({
      City: doc._id, // city name
      Orders: doc.orders?.length ?? 0,
      Products: doc.products ?? 0,
      Card: (doc.card + (doc.otherCard ?? 0)).toFixed(2),
      Cash: (doc.cash + (doc.otherCash ?? 0)).toFixed(2),
      Cashfree: (doc.cashfree + (doc.otherCashfree ?? 0)).toFixed(2),
      Ma: (doc.ma + (doc.otherMa ?? 0)).toFixed(2),
      Online: doc.online?.toFixed(2),
      Udhar: (doc.udhar + (doc.otherLoaned ?? 0))?.toFixed(2),
      Replace: (doc.otherReplace ?? 0)?.toFixed(2),
      Total: doc.total?.toFixed(2),
    }));

    const workSheet = Xlsx.utils.json_to_sheet(data);
    const workBook = Xlsx.utils.book_new();
    Xlsx.utils.book_append_sheet(workBook, workSheet, "City Summary");

    Xlsx.writeFile(workBook, `${dateGte}-${dateLte}-city-summary.xlsx`);
    setExportLoading(false);
  };

  return (
    <motion.div>
      <motion.div className="header">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Link to={-1} style={{ width: 40 }}>
            <TbArrowBackUp className="icoAdjust" />
          </Link>
          <Text b>City Report</Text>
        </div>
        <div className="headerLink headerLinkAddon" style={{ width: 200 }}>
          <Button
            auto
            size="sm"
            color="error"
            icon={
              exportLoading ? (
                <Loading type="spinner" color="white" />
              ) : (
                <TbFileExport />
              )
            }
            onClick={downloadExcel}
          />
        </div>
      </motion.div>
      <motion.div className="tableDiv alignDivCenter">
        {loading ? (
          <Loading type="spinner" />
        ) : (
          <Fragment>
            {error && (
              <Text
                color="error"
                css={{
                  br: "12px",
                  bgColor: "$red50",
                  py: "5px",
                  px: "10px",
                  my: "10px",
                }}
              >
                An error occured while trying to retrieve data from the server!
              </Text>
            )}
            <ReportTable
              list={currentListAdj ?? []}
              sortFunction={changeCurrentSort}
              asc={currentSort.asc}
              setValue={setCurrentSearch}
              value={currentSearch}
            />
          </Fragment>
        )}
      </motion.div>
    </motion.div>
  );
};

export default CityReport;
